<script setup lang="ts">
import LoginAndRegistration from '../../components/Account/LoginAndRegistration.vue';

await useAuthentication().rerouteIfLoggedIn();

const { accountBreadcrumbs } = useStaticBreadcrumbs();

useBreadcrumbs(accountBreadcrumbs({ type: 'login' }));
useAnalytics({ trackPageView: true, pageType: 'login' });
</script>

<template>
    <LoginAndRegistration />
</template>
